/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Vue from 'vue'
import HttpProvider from '@/services/HttpProvider'
import Config from '@/config'
import { restWithCache } from '@/store/lib/search'
import { findActiveCountry, EventBus } from '@/helpers'
import find from 'lodash/find'

export default {
  getCookieTime (ctx) {
    // console.log('action ', arguments)
    let cookieValue = global.$cookies.get('cookieNotifyShowed')
    if (cookieValue) {
      cookieValue = JSON.parse(cookieValue)
    }
    ctx.commit('setCookieTime', !!cookieValue)
  },
  loadMenu (ctx) {
    // load categories
    if (ctx.state.menu.length) {
      return Promise.resolve(ctx.state.menu)
    } else {
      const arrPromise = [
        ctx.dispatch('category/load', {}, { root: true })
      ]
      return Promise.all(arrPromise)
        .then(res => {
          const menu = res[1]
          const placeHolderCategory = find(menu, { type: 'shop' })
          if (placeHolderCategory) {
            Vue.set(placeHolderCategory, 'root', ctx.rootState.category.list)
          }
          ctx.commit('saveMenu', menu)
          return ctx.state.menu
        })
    }
  },
  showMiniCart (ctx, visible) {
    if (visible && ctx.rootState.cart.updateMinicart) {
      ctx.commit('loadingMiniCart', true)
      ctx.commit('cart/updateMinicart', false, { root: true })
      ctx.dispatch('cart/totals', false, { root: true })
        .finally(() => {
          ctx.commit('loadingMiniCart', false)
        })
    }
    ctx.commit('showMiniCart', visible)
  },
  loadCountries (ctx) {
    let url = Config.API.countries.allCountries
    if (ctx.state.countries === null) {
      return restWithCache({
        query: url,
        restPromise: HttpProvider.get(url)
      }).then(resp => {
        ctx.commit('setCountries', resp)
        return resp
      })
    }
    return Promise.resolve(ctx.state.countries)
  },
  loadCountry (ctx) {
    ctx.dispatch('loadCountries').then(resp => {
      let currentStoreViewCode = ctx.state.storeViewCode
      let $cookieCountry = global.$cookies.get('geolocator:country')
      let $cookieArea = global.$cookies.get('geolocator:state')
      let currentCountry
      $cookieCountry = checkValidCountry($cookieCountry, $cookieArea, resp, currentStoreViewCode)
      if (($cookieCountry === 'null' || $cookieCountry === null) && Object.keys(resp).length) {
        // find first and set
        for (let i in resp) {
          currentCountry = findActiveCountry(resp, null, i, currentStoreViewCode)
          if (currentCountry) {
            $cookieArea = i
            break
          }
        }
      } else if (($cookieCountry !== 'null' || $cookieCountry !== null) && Object.keys(resp).length) {
        currentCountry = findActiveCountry(resp, $cookieCountry, $cookieArea, currentStoreViewCode)
      }
      ctx.commit('setStateArea', $cookieArea)
      ctx.commit('setCountry', currentCountry)
      EventBus.$emit('country:loaded')
    })
  },
  init (ctx) {
    if (process.client) {
      if (window.sessionStorage) {
        const sizeCountrySelected = window.sessionStorage.getItem('sizeCountrySelected')
        sizeCountrySelected && ctx.commit('sizeCountrySelected', sizeCountrySelected)
      }
      if (window.localStorage) {
        const listingColumns = window.localStorage.getItem('listingColumns')
        listingColumns && ctx.commit('setListingColumns', listingColumns)
      }
    }
  }
}

function checkValidCountry (country, area, listArea, currentStoreView) {
  if (country && country !== 'null') {
    // check if is valid country
    if (listArea[area]) {
      let findCountry = find(listArea[area], { country })
      if (findCountry && findCountry.store_view === currentStoreView) {
        return country
      }
    }
  }
  return null
}
